import React from 'react'
import {
  Tooltip,
  TOOLTIP_TRIGGERS,
  TooltipOverlayType,
  TooltipPositions,
} from '../Tooltip'

export const PlainTooltip = ({
  id,
  children,
  tooltipBody,
  show,
  trigger,
  disabled,
  placement = TooltipPositions.default,
  width,
  keepOpenOnHover,
}: {
  id: string
  children: React.ReactElement
  tooltipBody: React.ReactNode
  trigger?: TOOLTIP_TRIGGERS | TOOLTIP_TRIGGERS[]
  show?: boolean
  disabled?: boolean
  placement?: TooltipPositions
  width?: number
  keepOpenOnHover?: boolean
}): JSX.Element => {
  return (
    <Tooltip
      id={id}
      overlayType={TooltipOverlayType.popover}
      tooltipBody={tooltipBody}
      show={show}
      trigger={trigger || [TOOLTIP_TRIGGERS.HOVER, TOOLTIP_TRIGGERS.FOCUS]}
      disabled={disabled}
      placement={placement}
      width={width}
      hideArrow={true}
      keepOpenOnHover={keepOpenOnHover}
    >
      {children}
    </Tooltip>
  )
}
